import React from "react";
import { useNotaire } from "../context/NotaireContext";
import { Link } from 'react-router-dom';
import styled from "styled-components";
import "react-toastify/dist/ReactToastify.css";
//catalyst tailwind
import { Input } from '../components/catalyst/input';
import { Heading } from '../components/catalyst/heading';
import PanelNotaireInfo from "./fiche_notaire/PanelNotaireInfo";
import PanelNotaireAdresse from "./fiche_notaire/PanelNotaireAdresse";
import PanelNotairePresentation from "./fiche_notaire/PanelNotairePresentation";
import PanelNotaireCompetences from "./fiche_notaire/PanelNotaireCompetences";
import PanelNotaireSpecialite from "./fiche_notaire/PanelNotaireSpecialites";
import PanelNotaireServices from "./fiche_notaire/PanelNotaireServices";
import PanelNotaireHoraires from "./fiche_notaire/PanelNotaireHoraires";
import PanelNotairePhoto from "./fiche_notaire/PanelNotairePhoto";
import PanelNotaireLangues from "./fiche_notaire/PanelNotaireLangues";


export const ColListeTransac = styled.div`
display:flex;
flex-direction:row;
gap:1rem;
flex-wrap:wrap;
justify-content:start;
@media all and (max-width: 768px) {
}
`;
export const InputLink = styled(Input)`
background-color:#dee2e6;
margin-top:.5rem;
`;


function FicheNotaire(args, props, value, rest) {
    const context = useNotaire();
    //console.log("context fiche", context)

    if (context.user !== null) {
        return (
            <div className="container">
                <div className="flex w-full flex-wrap items-end justify-between gap-4 border-b border-zinc-950/10 pb-6 dark:border-white/10">
                    <Heading>Votre page comptable</Heading>
                    <div className="flex gap-4">
                        <Link to={context.infoNotaire.lien_fiche} target="_blank" class="btn-primary inline-flex">
                            Voir mon profil comptable
                        </Link>

                    </div>
                </div>
                <PanelNotairePhoto/><br/>
                <PanelNotaireInfo/>
                <PanelNotaireAdresse/>
                <PanelNotairePresentation/>
                
                <PanelNotaireCompetences/>
                <PanelNotaireSpecialite/>
                <PanelNotaireServices/>
                <PanelNotaireHoraires/>
                <PanelNotaireLangues/>
                

            </div >
        )
    }
}

export default FicheNotaire;